export default __webpack_public_path__ + "static/bg-secondary-xs-ace4de16164d2fdbbe1fa3041616626b.jpg";